module.exports = __webpack_public_path__ + "img/2.597bec34.svg";